import React from 'react';
import {
  AuthenticatedTemplate,
  UnauthenticatedTemplate,
  useMsal,
} from '@azure/msal-react';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { loginRequest } from './msalConfig';

export function AuthProvider({ children }: { children: React.ReactNode }) {
  const { instance } = useMsal();

  const handleLogin = () => {
    instance.loginRedirect(loginRequest);
  };

  return (
    <>
      <AuthenticatedTemplate>{children}</AuthenticatedTemplate>
      <UnauthenticatedTemplate>
        <Box sx={{ display: 'flex', minHeight: '100vh', alignItems: 'center', justifyContent: 'center', bgcolor: 'grey.50' }}>
          <Paper sx={{ width: '100%', maxWidth: 400, p: 4, textAlign: 'center' }} elevation={2}>
            <Box component="img" src="/logo.png" alt="Kristiansund kommune" sx={{ width: 120, mb: 2 }} />
            <Typography variant="h1" sx={{ mb: 2 }}>
              InntektsAnalyse
            </Typography>
            <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
              Logg inn med din kommunale konto for å fortsette.
            </Typography>
            <Button variant="contained" fullWidth onClick={handleLogin}>
              Logg inn med Entra ID
            </Button>
          </Paper>
        </Box>
      </UnauthenticatedTemplate>
    </>
  );
}
